
export const INPUT_CHANGE = "[ADD TAXONOMY] INPUT_CHANGE";
export const INPUT_ERROR = "[ADD TAXONOMY] INPUT ERROR";

export const ADD_TAXONOMY_REQUEST = "[ADD TAXONOMY] ADD TAXONOMY REQUEST";
export const ADD_TAXONOMY_SUCCESS = "[ADD TAXONOMY] ADD TAXONOMY SUCCESS";
export const ADD_TAXONOMY_ERROR = "[ADD TAXONOMY] ADD TAXONOMY ERROR";

export const RESET_FORM = "[ADD TAXONOMY] RESET_FORM";

export const inputChange = ({ inputName, inputValue }) => ({ type: INPUT_CHANGE, inputName, inputValue });
export const inputError = ({ field, error }) => ({ type: INPUT_ERROR, field, error });

export const addTaxonomyRequest = history => ({ type: ADD_TAXONOMY_REQUEST, history });
export const addTaxonomySuccess = () => ({ type: ADD_TAXONOMY_SUCCESS });
export const addTaxonomyError = () => ({ type: ADD_TAXONOMY_ERROR });

export const resetForm = () => ({ type: RESET_FORM });


// WEBPACK FOOTER //
// ./src/modules/add-taxonomy/add-taxonomy-action-creators.js